import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { GoogleMap } from '@lib/geo/google/map';

import { LprQueryResultsModel } from '../../api/models';
import { FsQueryReadAdvancedMarker } from '../query-read-advanced-marker';

@Component({
  selector: 'fs-query-results-map-view',
  templateUrl: './query-results-map-view.component.html',
  styleUrls: ['./query-results-map-view.component.scss'],
})
export class QueryResultsMapViewComponent implements OnInit {
  public length: number;
  public index: number;
  public strokeWeight: string;
  public content: any;
  public plateLocation: number[];
  public marker: FsQueryReadAdvancedMarker;
  private _map: GoogleMap;

  constructor(@Inject(MAT_DIALOG_DATA) public plate: LprQueryResultsModel) {
    this.plateLocation = this.plate.geometry.coordinates;
  }

  public ngOnInit(): void {}

  public onMapInit(googleMap: GoogleMap): void {
    this._map = googleMap;
    this.marker = new FsQueryReadAdvancedMarker(this.plate);
    this.marker.addTo(googleMap);
  }

  public zoomIn(): void {
    this._map.setZoom(this._map.getZoom() + 1);
  }

  public zoomOut(): void {
    this._map.setZoom(this._map.getZoom() - 1);
  }

  public isLprQueryModel(plate: any): boolean {
    return !plate['integratedLprType'];
  }

  public isFlockResult(plate: any): boolean {
    return plate['integratedLprType'] === 'flock';
  }
}
